import { Link } from "react-router-dom";

export default function Page_not_found(){
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 text-center">
        <h1 className="text-9xl font-bold text-gray-800">404</h1>
        <h2 className="text-3xl font-semibold text-gray-700 mt-4">
          Oops! Page Not Found
        </h2>
        <p className="text-gray-600 mt-2">
          The page you're looking for doesn't exist or has been moved.
        </p>
        {/* <img
          src="https://via.placeholder.com/400x300"
          alt="Lost illustration"
          className="mt-6 w-80 h-auto"
        /> */}
        <div className="mt-8">
          <Link
            to="/home"
            className="px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg shadow hover:bg-blue-700"
          >
            Return to Homepage
          </Link>
        </div>
      </div>
    );
}